export const URL_PATHS = {
    root: () => "/",
    login: () => "/login",
    signup: () => "/signup",
    verifyCode: () => "/verify-code",
    registerPaid: () => "/register-paid",
    myPage: () => "/my-page",
    paymentCancel: () => "/payment-cancel",
    paymentCancelFinish: () => "/payment-cancel-finish",
    paymentMake: () => "/payment-make",
    paymentMake3DS: () => "/payment-make-3ds",
    paymentMakeFinish: () => "/payment-make-finish",
    creditCardInfoChangeFinish: () => "/credit-card-info-change-finish",
    paymentInfo: () => "/payment-info",
    paymentPlan: () => "/payment-plan",
    paymentPlanDetail: () => "/payment-plan-detail",
    paymentSystemChange: () => "/payment-system-change",
    subscriptionChangeFinish: () => "/subscription-change-finish",
    confirmTransition: () => "/confirm-transition",
    transitionFinish: () => "/transition-finish",
    paymentSystemChangeInfo: () => "/payment-system-change-info",
    transitionCancel: () => "/transition-cancel",
    transitionCancelFinish: () => "/transition-cancel-finish",
    paymentRestartConfirm: () => "/payment-restart-confirm",
    paymentRestartFinish: () => "/payment-restart-finish",
    logout: () => "/logout",
    incompleteRegister: () => "/incomplete-register",
    installApp: () => "/install-app",
    cancelSubscriptionProcedure: () => "/cancel-subscription-procedure",
    emailUnsubscribe: () => "/email-unsubscribe", // NOTE: sam-email-notificationsで使われているので、変更しないでください
    contractPaidMember: () => "/contract-paid-member",
    withdrawalApply: () => "/withdrawal-apply",
    withdrawalApplyFinish: () => "/withdrawal-apply-finish"
} as const;
